export default "__VITE_ASSET__CXud9E6S__"